import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { addLocale, locale } from "primereact/api";
import { getPrimeLocale } from "./utils/locale";

import ptConfigurationsIndex from "./locales/pt/views/configurations/index.json";
import enConfigurationsIndex from "./locales/en/views/configurations/index.json";
import esConfigurationsIndex from "./locales/es/views/configurations/index.json";

import ptConfigurationsUser from "./locales/pt/views/configurations/user.json";
import enConfigurationsUser from "./locales/en/views/configurations/user.json";
import esConfigurationsUser from "./locales/es/views/configurations/user.json";

import ptCommonTranslation from "./locales/pt/commonTranslation.json";
import enCommonTranslation from "./locales/en/commonTranslation.json";
import esCommonTranslation from "./locales/es/commonTranslation.json";


import ptMultiSelect from "./locales/pt/components/MultiSelect.json";
import enMultiSelect from "./locales/en/components/MultiSelect.json";
import esMultiSelect from "./locales/es/components/MultiSelect.json";

import ptDashboardSkeleton from "./locales/pt/components/dashboardSkeleton.json";
import enDashboardSkeleton from "./locales/en/components/dashboardSkeleton.json";
import esDashboardSkeleton from "./locales/es/components/dashboardSkeleton.json";

import ptcommonSkeleton from "./locales/pt/components/commonSkeleton.json";
import encommonSkeleton from "./locales/en/components/commonSkeleton.json";
import escommonSkeleton from "./locales/es/components/commonSkeleton.json";

import ptCampaignsView from "./locales/pt/views/campaigns.json";
import enCampaignsView from "./locales/en/views/campaigns.json";
import esCampaignsView from "./locales/es/views/campaigns.json";

import ptAds from "./locales/pt/views/ads.json";
import enAds from "./locales/en/views/ads.json";
import esAds from "./locales/es/views/ads.json";

import ptCommonPagination from "./locales/pt/components/CommonPagination.json";
import enCommonPagination from "./locales/en/components/CommonPagination.json";
import esCommonPagination from "./locales/es/components/CommonPagination.json";

import ptLeads from "./locales/pt/views/leads.json";
import enLeads from "./locales/en/views/leads.json";
import esLeads from "./locales/es/views/leads.json";

import ptimpactedCompanies from "./locales/pt/views/impactedCompanies.json";
import enimpactedCompanies from "./locales/en/views/impactedCompanies.json";
import esimpactedCompanies from "./locales/es/views/impactedCompanies.json";


import ptLogin from "./locales/pt/views/login.json";
import enLogin from "./locales/en/views/login.json";
import esLogin from "./locales/es/views/login.json";

import ptsparkProspects from "./locales/pt/views/sparkProspects.json";
import ensparkProspects from "./locales/en/views/sparkProspects.json";
import essparkProspects from "./locales/es/views/sparkProspects.json";


import ptErase from "./locales/pt/views/exclusion.json";
import enErase from "./locales/en/views/exclusion.json";
import esErase from "./locales/es/views/exclusion.json";

import ptRoutes from "./locales/pt/routes.json";
import enRoutes from "./locales/en/routes.json";
import esRoutes from "./locales/es/routes.json";

import ptExports from "./locales/pt/views/configurations/exports.json";
import enExports from "./locales/en/views/configurations/exports.json";
import esExports from "./locales/es/views/configurations/exports.json";

import ptErrors from "./locales/pt/errors.json";
import enErrors from "./locales/en/errors.json";
import esErrors from "./locales/es/errors.json";

const BASE_LOCALES = {
  "pt": {
    firstDayOfWeek: 0,
    dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
    monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    today: "Hoje",
    clear: "Limpar",
    weekHeader: "Sem",
    dateFormat: "dd/mm/yy"
  },
  "en": {
    firstDayOfWeek: 0,
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    today: "Today",
    clear: "Clear",
    weekHeader: "Wk",
    dateFormat: "mm/dd/yy"
  },
  "es": {
    firstDayOfWeek: 1,
    dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    today: "Hoy",
    clear: "Limpiar",
    weekHeader: "Sem",
    dateFormat: "dd/mm/yy"
  }
};

// 🔧 Utilitário para detectar a base segura do idioma
function getSafeLocale(lang) {
  return getPrimeLocale(lang);
}

// 🔄 Registra apenas as bases necessárias
const registeredBases = Object.entries(BASE_LOCALES);

registeredBases.forEach(([base, config]) => {
  addLocale(base, config);
});

// Garante que todas as variantes como en-GB, en-AU, pt-PT, es-MX usem as configurações base
const userLocale = navigator.language; // Ex: en-GB
const baseMatch = getSafeLocale(userLocale); // Ex: en-US
addLocale(userLocale, BASE_LOCALES[baseMatch]);

// 🔁 Atualiza ao mudar de idioma
i18n.on("languageChanged", (lng) => {
  const safe = getSafeLocale(lng);
  locale(safe);
  document.documentElement.lang = safe;
});

const resources = {
  pt: {
    settingss: ptConfigurationsIndex,
    "settingss/user": ptConfigurationsUser,
    "commonTranslation": ptCommonTranslation,
    "components/MultiSelect": ptMultiSelect,
    "components/commonPagination": ptCommonPagination,
    "components/dashboardSkeleton": ptDashboardSkeleton,
    "components/commonSkeleton": ptcommonSkeleton,
    "views/campaigns": ptCampaignsView,
    "views/leads": ptLeads,
    "views/impactedCompanies": ptimpactedCompanies,
    "views/sparkProspects": ptsparkProspects,
    "views/exclusion": ptErase,
    "views/ads": ptAds,
    "views/login": ptLogin,
    routes: ptRoutes,
    exports: ptExports,
    errors: ptErrors,
  },
  en: {
    settingss: enConfigurationsIndex,
    "settingss/user": enConfigurationsUser,
    "commonTranslation": enCommonTranslation,
    "components/MultiSelect": enMultiSelect,
    "components/commonPagination": enCommonPagination,
    "components/dashboardSkeleton": enDashboardSkeleton,
    "components/commonSkeleton": encommonSkeleton,
    "views/campaigns": enCampaignsView,
    "views/leads": enLeads,
    "views/impactedCompanies": enimpactedCompanies,
    "views/sparkProspects": ensparkProspects,
    "views/exclusion": enErase,
    "views/ads": enAds,
    "views/login": enLogin,
    routes: enRoutes,
    exports: enExports,
    errors: enErrors,
  },
  es: {
    settingss: esConfigurationsIndex,
    "settingss/user": esConfigurationsUser,
    "commonTranslation": esCommonTranslation,
    "components/MultiSelect": esMultiSelect,
    "components/commonPagination": esCommonPagination,
    "components/dashboardSkeleton": esDashboardSkeleton,
    "components/commonSkeleton": escommonSkeleton,
    "views/campaigns": esCampaignsView,
    "views/leads": esLeads,
    "views/impactedCompanies": esimpactedCompanies,
    "views/sparkProspects": essparkProspects,
    "views/exclusion": esErase,
    "views/ads": esAds,
    "views/login": esLogin,
    routes: esRoutes,
    exports: esExports,
    errors: esErrors,
  },
};

// Define idioma do calendário e <html lang> imediatamente, antes de qualquer render
const navigatorLang = navigator.language || "en";
const initialSafe = getSafeLocale(navigatorLang);

locale(initialSafe);
document.documentElement.lang = initialSafe;

i18n.initPromise = i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    defaultNS: "commonTranslation",
    interpolation: { escapeValue: false },
    supportedLngs: ["en", "pt", "es"],
    nonExplicitSupportedLngs: true, // trata en-GB como en, pt-BR como pt etc.
    load: "languageOnly",

    detection: {
      order: ["localStorage", "navigator", "htmlTag", "cookie"],
      caches: ["localStorage"],
    },
  })
  .then(() => {
    const safeLang = getSafeLocale(i18n.language);
    locale(safeLang);
    document.documentElement.lang = safeLang;
  });

export default i18n;
